import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import '../Customers/CustomersStyle.css';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import FailureAlert from '../Common/Failure';
import moment from 'moment';
import { ThemeContext } from '../Common/ThemeProvider';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

const LRDetails = {
    SurveyID: "",
    PartnerID: "",
    JobID: 0,
    Packages: "",
    Description: "",
    ActualWeight: 0,
    ChargeWeight: "",
    PaidBy: 0,
    Payment: 0,
    FreightCharges: 0,
    FuelCharges: 0,
    OtherCharges: 0,
    CGST: 0,
    SGST: 0,
    IGST: 0,
    OrgID: "",
    CreatedBy: "",
    TruckNumber: "",
    DeliveryNote: "",
    TentativeDeliveryDate: null,
    Status: 1,
    IsDeleted: 0,
}

const CreateLR = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [Quotations, setQuotations] = useState([]);
    const [Partners, setPartners] = useState([]);
    const [QuotationsData, setQuotationsData] = useState([]);
    const [PartnerData, setPartnerData] = useState([]);
    const [SelectedQuotation, setSelectedQuotation] = useState({});
    const [SelectedQuotationDrop, setSelectedQuotationDrop] = useState({ label: null, value: null });
    const [SelectedPartnerDrop, setSelectedPartnerDrop] = useState({ label: null, value: null });
    const [SelectedPartner, setSelectedPartner] = useState({});
    const [Edit, setEdit] = useState(false);
    const [LRID, setLRID] = useState([]);
    const [FilterLRData, setFilterLRData] = useState([]);
    const [SelectedLR, setSelectedLR] = useState("");
    const [LRData, setLRData] = useState(LRDetails);

    useEffect(() => {
        FetchCustmers();
        FetchPartners();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const FetchCustmers = () => {
    //     var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
    //     if (userData !== null) {
    //         Axiosfetch(baseURL + "GetQuotationsWithApprovedSurvey", "POST", { OrgID: userData.OrganizationID }, QuotationSuccess, Failure);
    //     }
    // };

    const FetchCustmers = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData !== null) {
            Axiosfetch(baseURL + "GetRawActiveQuotationsByOrgID", "POST", { OrgID: userData.OrganizationID }, QuotationSuccess, Failure);
        }
    };

    const FetchPartners = () => {
        Axiosfetch(baseURL + "GetActiveOrganizations", "GET", null, PartnerSuccess, Failure);
    };

    const PartnerSuccess = (data) => {
        if (data.length > 0) {
            setPartnerData(data);
            var partnerData = [];
            var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
            data.forEach(partner => {
                if (userData.OrganizationID !== partner._id &&
                    ((partner.ExpiryDate === undefined || partner.ExpiryDate === null) ||
                        (partner.ExpiryDate !== "" && moment() < moment(partner.ExpiryDate)))) {
                    partnerData.push({ label: partner.Name + " [MFI " + partner.City + "]", value: partner._id })
                }
            });

            setPartners(partnerData);
        }
    };


    const QuotationSuccess = (data) => {
        if (data.length > 0) {
            setQuotationsData(data);
            var quotationData = [];
            data.forEach(value => {
                let QuotationNumber = "#" + value.QuoteID + "_" + moment(value.createdAt).local().format("DDMMYYYY");
                quotationData.push({ value: value.QuoteID, label: QuotationNumber });
            });

            setQuotations(quotationData);
        }
    };


    const OnQuotationChange = (quotationData) => {
        let quotation = quotationData ? quotationData.value : "";
        if (quotation !== "") {
            let quote = QuotationsData.filter(c => c.QuoteID === quotation);
            if (quote.length > 0) {
                setSelectedQuotation(quote[0]);

                let QuotationNumber = "#" + quote[0].QuoteID + "_" + moment(quote[0].createdAt).local().format("DDMMYYYY");
                setSelectedQuotationDrop({ value: quote[0].QuoteID, label: QuotationNumber });

                let LRDataByQuotationID = LRDetails;
                LRDataByQuotationID.FreightCharges = (quote[0].PackingCharges + quote[0].LoadingCharges + quote[0].PickupCharges +
                    quote[0].TransportCharges + quote[0].UnpackingCharges + quote[0].UnloadingCharges +
                    quote[0].CarTransportCharges);
                LRDataByQuotationID.OtherCharges = quote[0].OtherCharges;
                setLRData(LRDataByQuotationID);
            }
            else {
                setSelectedQuotation({});
                setSelectedQuotationDrop({ value: null, label: null });
                let lr = LRDetails;
                lr.FreightCharges = 0;
                lr.OtherCharges = 0;
                lr.FuelCharges = 0;
                setLRData(lr);
            }
        }
        else {
            setSelectedQuotation({});
            setSelectedQuotationDrop({ value: null, label: null });
            let lr = LRDetails;
            lr.FreightCharges = 0;
            lr.OtherCharges = 0;
            lr.FuelCharges = 0;
            setLRData(lr);
        }
    };

    const OnPartnerChange = (partnerData) => {
        let partner = partnerData ? partnerData.value : "";
        if (partner !== "") {
            let ptnr = PartnerData.filter(c => c._id === partner);
            if (ptnr.length > 0) {
                setSelectedPartner(ptnr[0]);
                setSelectedPartnerDrop({ label: ptnr[0].Name + " [MFI " + ptnr[0].City + "]", value: ptnr[0]._id });
            }
            else {
                setSelectedPartner({});
                setSelectedPartnerDrop({ label: null, value: null })
            }
        }
        else {
            setSelectedPartner({});
            setSelectedPartnerDrop({ label: null, value: null });
        }
    };

    const onTextChange = (e) => {
        setLRData({ ...LRData, [e.target.name]: e.target.value })
    };

    const onNumberChange = (e) => {
        setLRData({ ...LRData, [e.target.name]: parseFloat(e.target.value) })
    };

    const OnCheckChange = (type, value) => {
        setLRData({ ...LRData, [type]: value })
    };

    const SaveLR = () => {
        if (ValidateLR()) {
            var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
            if (userData !== null) {
                var LRDetails = LRData;

                if (Edit && SelectedLR !== "") {
                    LRDetails._id = SelectedLR;
                    Axiosfetch(baseURL + "EditLorryReciept", "POST", LRDetails, LRCreateSuccess, Failure);
                }
                else {
                    LRDetails.QuotationID = SelectedQuotation._id;
                    LRDetails.SurveyID = SelectedQuotation.CustomerID;
                    LRDetails.PartnerID = SelectedPartner._id;
                    LRDetails.OrgID = userData.OrganizationID;
                    if (SelectedQuotation && SelectedQuotation.IsInstant === 1) {
                        LRDetails.TentativeDeliveryDate = LRData.TentativeDeliveryDate ? moment.utc(LRData.TentativeDeliveryDate) : null;
                    }

                    LRDetails.JobID = moment().format("DDMMYYhhmmss");
                    LRDetails.CreatedBy = userData._id;
                    Axiosfetch(baseURL + "CreateLorryReciept", "POST", LRDetails, LRCreateSuccess, Failure);
                }
            }
        }
    };

    const ValidateLR = () => {
        let LRErr = "";
        if (SelectedQuotation._id === undefined) {
            LRErr = "Please select Quotation.";
        }
        else if (SelectedPartner._id === undefined) {
            LRErr = "Please select patner.";
        }
        else if (LRData.Packages === "") {
            LRErr = "Please enter packes Info.";
        }
        else if (LRData.ActualWeight <= 0) {
            LRErr = "Please enter valid Actual Weight.";
        }
        else if (LRData.ChargeWeight === "") {
            LRErr = "Please enter Charge.";
        }
        else if ((SelectedQuotation.InstantCustomerGSTAvailable === 1 ||
            (SelectedQuotation && SelectedQuotation.Customer && SelectedQuotation.Customer.length > 0 && SelectedQuotation.Customer[0].IsGSTAvailable === 1)) && LRData.PaidBy <= 0) {
            LRErr = "Please select Paid By.";
        }
        else if (LRData.Payment <= 0) {
            LRErr = "Please select Payment info.";
        }
        else if (LRData.FreightCharges <= 0) {
            LRErr = "Please enter valid Freight charges.";
        }
        else if ((SelectedQuotation.InstantCustomerGSTAvailable === 1 ||
            (SelectedQuotation && SelectedQuotation.Customer && SelectedQuotation.Customer.length > 0 && SelectedQuotation.Customer[0].IsGSTAvailable === 1)) && ((LRData.CGST <= 0 || LRData.SGST <= 0) && LRData.IGST <= 0)) {
            LRErr = "Please enter valid GST.";
        }
        else if (LRData.TruckNumber === "") {
            LRErr = "Please enter Truck Number.";
        }

        if (LRErr !== "") {
            Alert.error(LRErr, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };

    const LRCreateSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            setSelectedQuotation({});

            let lr = LRDetails;
            lr.FreightCharges = 0;
            lr.OtherCharges = 0;
            lr.FuelCharges = 0;
            setLRData(lr);

            setEdit(false);
        }
    };

    const OnLREdit = (e) => {
        setEdit(e.target.checked);
        if (e.target.checked) {
            FetchLR();
        }
        else {
            setSelectedQuotationDrop({ value: null, label: null });
            setSelectedPartnerDrop({ label: null, value: null });
        }

        let lr = LRDetails;
        lr.FreightCharges = 0;
        lr.OtherCharges = 0;
        lr.FuelCharges = 0;
        setLRData(lr);
    };

    const FetchLR = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        Axiosfetch(baseURL + "GetLorryRecieptByOrgID", "POST", { OrgID: userData.OrganizationID }, LRIDsSuccess, Failure);
    };

    const LRIDsSuccess = (data) => {
        if (data.length > 0) {
            var lrData = [];
            setLRID(data);
            data.forEach(lr => {
                lrData.push({ label: lr.JobID, value: lr._id })
            });

            setFilterLRData(lrData);
        }
        else {
            setFilterLRData([]);
        }
    };

    const OnLRChange = (lrDetails) => {
        let lr = lrDetails ? lrDetails.value : "";
        setSelectedLR(lr);
        if (lr !== "") {
            let lrfetch = LRID.filter(c => c._id === lr);

            if (lrfetch.length > 0 && lrfetch[0].PartnerOrg.length > 0 && lrfetch[0].Quotation.length > 0) {
                let QuotationNumber = "#" + lrfetch[0].Quotation[0].QuoteID + "_" + moment(lrfetch[0].Quotation[0].createdAt).local().format("DDMMYYYY");
                setSelectedQuotationDrop({ value: lrfetch[0].Quotation[0].QuoteID, label: QuotationNumber });
                setSelectedPartnerDrop({ label: lrfetch[0].PartnerOrg[0].Name + " [MFI " + lrfetch[0].PartnerOrg[0].City + "]", value: lrfetch[0].PartnerOrg[0]._id })

                let quote = QuotationsData.filter(c => c.QuoteID === lrfetch[0].Quotation[0].QuoteID);
                if (quote.length > 0) {
                    setSelectedQuotation(quote[0]);
                }
                else {
                    setSelectedQuotation({});
                }

                let ptnr = PartnerData.filter(c => c._id === lrfetch[0].PartnerOrg[0]._id);
                if (ptnr.length > 0) {
                    setSelectedPartner(ptnr[0]);
                }
                else {
                    setSelectedPartner({});
                }
            }
            else {
                setSelectedQuotationDrop({ label: null, value: null });
                setSelectedPartnerDrop({ label: null, value: null });
            }


            if (lrfetch.length > 0) {
                Axiosfetch(baseURL + "GetLorryRecieptByID", "POST", { _id: lrfetch[0]._id }, LRSuccess, Failure);
            }
        }
        else {
            setLRData(LRDetails);
            setSelectedQuotationDrop({ value: null, label: null });
            setSelectedPartnerDrop({ label: null, value: null })
        }
    };

    const onTentativeDeliveryDateChange = (data) => {
        setLRData({ ...LRData, "TentativeDeliveryDate": data });
    };

    const LRSuccess = (data) => {
        if (data.length > 0) {

            if (data[0].TentativeDeliveryDate) {
                data[0].TentativeDeliveryDate = new Date(data[0].TentativeDeliveryDate);
            }

            setLRData(data[0]);

            if (data[0].Quotation.length > 0) {
                let QuotationNumber = "#" + data[0].Quotation[0].QuoteID + "_" + moment(data[0].Quotation[0].createdAt).local().format("DDMMYYYY");
                setSelectedQuotationDrop({ value: data[0].Quotation[0].QuoteID, label: QuotationNumber });
            }
        }
        else {
            let lr = LRDetails;
            lr.FreightCharges = 0;
            lr.OtherCharges = 0;
            lr.FuelCharges = 0;
            setLRData(lr);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="col-md-1 col-4 align-right">
                        <span style={{ paddingRight: "10px" }}>Edit</span><input checked={Edit} onChange={OnLREdit} type="checkbox"></input>
                    </div>
                    <div className="offset-md-1 col-md-5 col-8 align-right responsive-align">
                        <h5 style={{ fontWeight: "500" }}>Lorry Reciept (LR)</h5>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end" }} className="col-md-5 col-12">
                        {Edit === true && (<div style={{ width: "70%", paddingRight: "1rem" }}>
                            <Select isClearable={true} isSearchable={true} placeholder="Select LR *"
                                options={FilterLRData}
                                onChange={OnLRChange}></Select>
                        </div>)}
                        <button onClick={SaveLR} className={`btn btn-General ${CurrentTheme}Focus`}>Save LR</button>
                    </div>
                </div>
                <div className="row" style={{ padding: "15px", height: "72vh", scrollbarColor: "#005582 transparent" }}>
                    <div className="offset-md-2 col-md-4 col-sm-4 align-center">
                        <div style={{ width: "100%", paddingBottom: "5px" }}>
                            <Select value={SelectedQuotationDrop.value <= 0 ? '' : SelectedQuotationDrop} isClearable={true} isSearchable={true} placeholder="Select Quotation *"
                                options={Quotations}
                                onChange={OnQuotationChange}></Select>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-4 align-center">
                        <div style={{ width: "100%", paddingBottom: "5px" }}>
                            <Select value={SelectedPartnerDrop.value <= 0 ? '' : SelectedPartnerDrop} isClearable={true} isSearchable={true} placeholder="Select Partner *"
                                options={Partners}
                                onChange={OnPartnerChange}></Select>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 align-center">
                        <div className="LRDocChkStyle">
                            <div className="cd-cards2 cd-cardboundry" style={{ border: "none", borderBottom: "1px solid #ccc" }}>
                                No. of Packages<span className="mandatoryStar">*</span>
                            </div>
                            <div style={{ padding: "10px" }}>
                                <textarea onChange={onTextChange} name="Packages" value={LRData.Packages} style={{ resize: "none" }} className="form-control"></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 align-center">
                        <div className="LRDocChkStyle">
                            <div className="cd-cards2 cd-cardboundry" style={{ border: "none", borderBottom: "1px solid #ccc" }}>
                                Goods Description
                            </div>
                            <div style={{ padding: "10px" }}>
                                <textarea onChange={onTextChange} name="Description" value={LRData.Description} style={{ resize: "none" }} className="form-control"></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 align-center">
                        <div className="LRDocChkStyle">
                            <div className="cd-cards2 cd-cardboundry" style={{ border: "none", borderBottom: "1px solid #ccc" }}>
                                Truck Number<span className="mandatoryStar">*</span>
                            </div>
                            <div style={{ padding: "10px" }}>
                                <input value={LRData.TruckNumber} type="text" name="TruckNumber" onChange={onTextChange} className="form-control align-center"></input>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 align-center">
                        <div className="LRDocChkStyle">
                            <div className="cd-cards2 cd-cardboundry" style={{ border: "none", marginBottom: "0.5rem", borderBottom: "1px solid #ccc" }}>
                                Weight<span className="mandatoryStar">*</span>
                            </div>
                            <div style={{ display: "flex" }}>
                                <div style={{ padding: "0 10px" }}>
                                    <span>Actual</span>
                                    <input onChange={onNumberChange} name="ActualWeight" value={LRData.ActualWeight} className="form-control" type="text"></input>
                                </div>
                                <div style={{ padding: "0 10px" }}>
                                    <span>Charge</span>
                                    <input onChange={onTextChange} name="ChargeWeight" value={LRData.ChargeWeight} className="form-control" type="text"></input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 align-center">
                        <div className="LRDocChkStyle">
                            <div className="cd-cards2 cd-cardboundry" style={{ border: "none", marginBottom: "1.5rem", borderBottom: "1px solid #ccc" }}>
                                GST Paid By {((SelectedQuotation && SelectedQuotation.InstantCustomerGSTAvailable === 1) ||
                                    (SelectedQuotation && SelectedQuotation.Customer && SelectedQuotation.Customer.length > 0 && SelectedQuotation.Customer[0].IsGSTAvailable === 1)) && (<span className="mandatoryStar">*</span>)}
                            </div>
                            <div style={{ margin: "auto", paddingBottom: "20px" }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td><span className="checkboxTextStyle">Consignor</span></td>
                                            <td> <div className="switch">
                                                <input checked={LRData.PaidBy === 1} onChange={() => OnCheckChange("PaidBy", 1)} id="switch-Consignor" type="checkbox" className="switch-input" />
                                                <label htmlFor="switch-Consignor" className="switch-label">Switch</label>
                                            </div></td>
                                        </tr>
                                        <tr>
                                            <td><span className="checkboxTextStyle">Consignee</span></td>
                                            <td>
                                                <div className="switch">
                                                    <input checked={LRData.PaidBy === 2} onChange={() => OnCheckChange("PaidBy", 2)} id="switch-Consignee" type="checkbox" className="switch-input" />
                                                    <label htmlFor="switch-Consignee" className="switch-label">Switch</label>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span className="checkboxTextStyle">Transnsporter</span></td>
                                            <td>
                                                <div className="switch">
                                                    <input checked={LRData.PaidBy === 3} onChange={() => OnCheckChange("PaidBy", 3)} id="switch-Transnsporter" type="checkbox" className="switch-input" />
                                                    <label htmlFor="switch-Transnsporter" className="switch-label">Switch</label>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 align-center">
                        <div className="LRDocChkStyle">
                            <div className="cd-cards2 cd-cardboundry" style={{ border: "none", marginBottom: "1rem", borderBottom: "1px solid #ccc" }}>
                                Payment<span className="mandatoryStar">*</span>
                            </div>
                            <div style={{ margin: "auto", paddingBottom: "25px" }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td><span className="checkboxTextStyle">Paid</span></td>
                                            <td>
                                                <div className="switch">
                                                    <input checked={LRData.Payment === 1} onChange={() => OnCheckChange("Payment", 1)} id="switch-Paid" type="checkbox" className="switch-input" />
                                                    <label htmlFor="switch-Paid" className="switch-label">Switch</label>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span className="checkboxTextStyle">To pay</span></td>
                                            <td>
                                                <div className="switch">
                                                    <input checked={LRData.Payment === 2} onChange={() => OnCheckChange("Payment", 2)} id="switch-ToPay" type="checkbox" className="switch-input" />
                                                    <label htmlFor="switch-ToPay" className="switch-label">Switch</label>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span className="checkboxTextStyle">To be Billed</span></td>
                                            <td>
                                                <div className="switch">
                                                    <input checked={LRData.Payment === 3} onChange={() => OnCheckChange("Payment", 3)} id="switch-ToBilled" type="checkbox" className="switch-input" />
                                                    <label htmlFor="switch-ToBilled" className="switch-label">Switch</label>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 align-center">
                        <div className="LRDocChkStyle">
                            <div className="cd-cards2 cd-cardboundry" style={{ border: "none", marginBottom: "0.5rem", borderBottom: "1px solid #ccc" }}>
                                Service Charges<span className="mandatoryStar">*</span>
                            </div>
                            <div style={{ margin: "auto", paddingBottom: "10px" }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="checkboxTextStyle">Freight</td>
                                            <td>
                                                <input readOnly name="FreightCharges" value={LRData.FreightCharges} className="form-control" type="number"></input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="checkboxTextStyle">Surcharge</td>
                                            <td>
                                                <input readOnly name="FuelCharges" value={LRData.FuelCharges} className="form-control" type="number"></input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="checkboxTextStyle">Others</td>
                                            <td>
                                                <input readOnly name="OtherCharges" value={LRData.OtherCharges} className="form-control" type="number"></input>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 align-center">
                        <div className="LRDocChkStyle">
                            <div className="cd-cards2 cd-cardboundry" style={{ border: "none", marginBottom: "0.5rem", borderBottom: "1px solid #ccc" }}>
                                GST {((SelectedQuotation && SelectedQuotation.InstantCustomerGSTAvailable === 1) ||
                                    (SelectedQuotation && SelectedQuotation.Customer && SelectedQuotation.Customer.length > 0 && SelectedQuotation.Customer[0].IsGSTAvailable === 1)) && (<span className="mandatoryStar">*</span>)}
                            </div>
                            <div style={{ margin: "auto", paddingBottom: "10px" }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="checkboxTextStyle">CGST</td>
                                            <td>
                                                <input onChange={onNumberChange} name="CGST" value={LRData.CGST ? LRData.CGST : 0} className="form-control" type="number"></input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="checkboxTextStyle">SGST</td>
                                            <td>
                                                <input onChange={onNumberChange} name="SGST" value={LRData.SGST ? LRData.SGST : 0} className="form-control" type="number"></input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="checkboxTextStyle">IGST</td>
                                            <td>
                                                <input onChange={onNumberChange} name="IGST" value={LRData.IGST ? LRData.IGST : 0} className="form-control" type="number"></input>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: "center", alignItems: "center" }} className="col-md-12 col-sm-12 align-center">
                        <div>
                            <div className="checkboxTextStyle">Delivery Note</div>
                            <textarea style={{ width: "30vw", resize: "none" }} rows="1" value={LRData.DeliveryNote} type="text" name="DeliveryNote" onChange={onTextChange} className="form-control align-center"></textarea>
                        </div>
                        {SelectedQuotation && SelectedQuotation.IsInstant === 1 && (<div style={{ width: "20vw" }}>
                            <div className="checkboxTextStyle">Tentative Delivery Date</div>
                            <DatePicker className="TextInputStyle datepicker"
                                selected={LRData.TentativeDeliveryDate}
                                onChange={onTentativeDeliveryDateChange}
                                name="tentativeDeliveryDate"
                                showTimeSelect
                                timeIntervals={15}
                                timeCaption="time"
                                dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                        </div>)}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default CreateLR;